/* istanbul ignore file */
/* tslint:disable */
 
import type { FileContentCreate } from '../models/FileContentCreate';
import type { FileContentEdit } from '../models/FileContentEdit';
import type { FileContentFull } from '../models/FileContentFull';
import type { PaginatedFileContentShortList } from '../models/PaginatedFileContentShortList';
import type { PresignedUploadUrl } from '../models/PresignedUploadUrl';
import type { RetrieveFileContent } from '../models/RetrieveFileContent';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class MediaService {

  /**
   * @param id 
   * @returns void 
   * @throws ApiError
   */
  public static mediaCountDestroy(
id: string,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/media/count/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns PresignedUploadUrl 
   * @throws ApiError
   */
  public static mediaCreateCreate(
requestBody: FileContentCreate,
): CancelablePromise<PresignedUploadUrl> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/media/create/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param requestBody 
   * @returns PresignedUploadUrl 
   * @throws ApiError
   */
  public static mediaCreateUnauthenticatedCreate(
requestBody: FileContentCreate,
): CancelablePromise<PresignedUploadUrl> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/media/create-unauthenticated/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param id 
   * @returns void 
   * @throws ApiError
   */
  public static mediaDeleteDestroy(
id: string,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/media/delete/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns FileContentFull 
   * @throws ApiError
   */
  public static mediaEditUpdate(
id: string,
requestBody?: FileContentEdit,
): CancelablePromise<FileContentFull> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/media/edit/{id}/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param id 
   * @returns RetrieveFileContent 
   * @throws ApiError
   */
  public static mediaGetUnauthenticatedRetrieve(
id: string,
): CancelablePromise<RetrieveFileContent> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/media/get-unauthenticated/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @returns RetrieveFileContent 
   * @throws ApiError
   */
  public static mediaGetRetrieve(
id: string,
): CancelablePromise<RetrieveFileContent> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/media/get/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param contentType * `image` - image
 * * `audio` - audio
 * * `video` - video
 * * `text` - text
 * * `attachment` - attachment
 * * `application` - application
   * @param page A page number within the paginated result set.
   * @param pageSize Number of results to return per page.
   * @param search 
   * @param status * `draft` - draft
 * * `published` - published
   * @returns PaginatedFileContentShortList 
   * @throws ApiError
   */
  public static mediaListList(
contentType?: 'image' | 'audio' | 'video' | 'text' | 'attachment' | 'application',
page?: number,
pageSize?: number,
search?: string,
status?: 'draft' | 'published',
): CancelablePromise<PaginatedFileContentShortList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/media/list/',
      query: {
        'content_type': contentType,
        'page': page,
        'page_size': pageSize,
        'search': search,
        'status': status,
      },
    });
  }

  /**
   * @returns any No response body
   * @throws ApiError
   */
  public static mediaWebhooksMinioCreate(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/media/webhooks/minio/',
    });
  }

}
